<template>
  <div class="data-grid-wrapper" :style="{height: bodyHeight, width: '100%'}">
    <Card class="data-grid" :bordered="false" :dis-hover="disHover">
        <searchbar ref="searchbar"
          @trigger="__calcContentHeight"
          @search="select(true)"
          v-model="model"
          :showButton="showButton"
          :items="items"/>
        <div class="data-grid-operator" ref="operator" v-show="$slots.operator">
            <slot name="operator"/>
        </div>
        <div class="data-grid-body" :style="{height: height}">
            <div class="data-grid-body-alert" ref="alert" v-show="$slots.alert || $scopedSlots.alert">
                <slot name="alert" :scope="pageModel"/>
            </div>
            <template>
              <el-table :data="list"
                :height="fixedHeight ? fixedHeight : !autoHeight ? tableHeight : undefined"
                ref="table"
                :lazy="lazy"
                :border="bordered"
                :load="onLoad"
                :row-key="autoId ? '$id' : ''"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                stripe
                v-loading="loading"
                @selection-change="handleSelectionChange"
                highlight-current-row>
                <slot :scope="pageModel"/>
              </el-table>
              <div class="data-grid-pagination" style="text-align:left;margin-top:12px;" v-show="page">
                  <el-pagination
                      background
                      style="display:inline-block;"
                      small
                      @size-change="onPageSizeChange"
                      @current-change="onCurrentPageChange"
                      :disabled="loading"
                      :page-sizes="pager"
                      :page-size="pageSize"
                      :current-page="pageNum"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total">
                  </el-pagination>
                  <el-button @click="select()" icon="el-icon-refresh" :loading="loading" circle title="刷新"></el-button>
              </div>
            </template>
        </div>
         <slot name="dialog"/>
    </Card>
  </div>
</template>

<script>
import Mixins from './data-grid-mixins.js'
import { addResizeListener, removeResizeListener } from '@/libs/resize-observer'
import bus from './bus'
export default {
  name: 'data-grid',
  mixins: [Mixins],
  props: {
    diffHeight: { // 计算表格高度时需要减去的高度
      type: Number,
      default: 0
    },
    // response: {
    //   type: Object,
    //   default () {
    //       return {}
    //   }
    // }
  },
    data () {
      return {
        alertHeight: 0,
        opeartorHeight: 0,
        loading: false,
        model: {},
        pageModel: {},
        list: [],
        query: {},
        pageNum: 1,
        total: 0,
        height: 0,
        id: 0,
        rowId: '$id',
        $pageSize: 25
      }
  },
  computed: {
    bodyHeight () {
      if (this.diffHeight !== undefined) return `calc(100% - ${this.diffHeight}px)`
      else return '100%'
    },
    tableHeight () {
      if (this.page) return `calc(100% - ${52 + this.alertHeight}px)`
      else return `calc(100% - 16px)`
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) this.model = val
      }
    },
    model: {
      deep: true,
      handler () {
        this.$emit('input', this.model)
      }
    },
    opeartorHeight () {
      this.__calcContentHeight()
    },
    pageSize: {
      immediate: true,
      handler (val) {
        this.$pageSize = val
      }
    }
  },
  methods: {
    genId (list = []) {
      if (!this.autoId) return
      list.forEach(item => {
        this.$set(item, '$id', ++this.id)
      })
    },
    // 对选
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    },
    clearSelection () {
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
    },
    /**
     * @description 查询
     * @param {Boolean} reload 是否从第一页开始查询
     * @author yangyu
     */
    select (reload = false, currentRow = '') {
      if (this.api) {
        if (reload) this.pageNum = 1
        this.loading = true
        return this.$api(this.api, {
          pageNum: this.pageNum,
          pageSize: this.$pageSize,
          ...this.params
        }).then(res => {
          if (!res) res = {}
          this.pageModel = JSON.parse(JSON.stringify(res))
          this.$emit('update:payload', this.pageModel)
          // this.response = JSON.parse(JSON.stringify(res))
          if (res && this.page && res.page) {
            this.genId(res.page.list)
            this.list = res.page.list
            this.pageNum = res.page.pageNum
            // this.pageSize = res.page.pageSize
            this.total = res.page.total
          } else {
            if (!Array.isArray(res)) res = []
            this.genId(res)
            this.list = res
          }
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.bodyWrapper.scrollTop = 0
              // 设置当前高亮
              if (currentRow && !this.autoId && typeof this.rowKey === 'string') {
                let currentIndex = this.list.findIndex(row => row[this.rowKey] === currentRow)
                if (currentIndex !== -1) {
                  this.$refs.table.setCurrentRow(this.list[currentIndex])
                }
              }
            }
          })
          this.loading = false
        }).catch(err => {
          if (process.env.NODE_ENV === 'development') console.error(err)
          this.$tips(err, 'error')
          this.loading = false
        })
      }
    },
    clear () {
      this.pageNum = 1
      this.list = []
      this.total = 0
    },
    /**
     * @description 加载子节点数据
     * @author yangyu
     */
    onLoad (tree, treeNode, resolve) {
      if (!this.lazyLoadApi) return
      let params = {}
      if (Array.isArray(this.lazyLoadParamNames)) {
        this.lazyLoadParamNames.forEach(k => {
          params[k] = tree[k]
        })
      } else {
        Object.keys(this.lazyLoadParamNames).forEach(k => {
          params[this.lazyLoadParamNames[k]] = tree[k]
        })
      }
      this.$api(this.lazyLoadApi, params).then(res => {
        if (res) {
          this.genId(res)
          resolve(res)
        }
      }).catch(err => {
        if (process.env.NODE_ENV === 'development') {
          console.error(err)
        }
        this.$tips(err, 'error')
      })
    },
    onCurrentPageChange (val) {
      this.pageNum = val
      this.select()
    },
    onPageSizeChange (val) {
      this.$pageSize = val
      this.select()
    },
    __calcContentHeight () {
      this.$nextTick(() => {
        if (!this.$refs.searchbar) {
          this.height = `calc(100% - ${this.opeartorHeight}px)`
        } else {
          this.height = `calc(100% - ${this.$refs.searchbar.$el.offsetHeight + this.opeartorHeight}px)`
        }
      })
    },
    onResize () {
      this.__calcContentHeight()
    },
    onAlertResize () {
      this.alertHeight = this.$refs.alert.offsetHeight
    },
    onOpearatorResize () {
      this.opeartorHeight = this.$refs.operator.offsetHeight
    },
    doLayout () {
      this.$nextTick(() => {
        this.__calcContentHeight()
      })
    }
    // 表格相关方法
  },
  created () {
    if (this.autoId) this.rowId = '$id'
    else this.rowId = this.rowKey
    if (this.autoSearch) {
      this.select(true)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.__calcContentHeight()
      bus.$on('on-tab-change', this.onResize)
      if (this.$refs.alert) {
        addResizeListener(this.$refs.alert, this.onAlertResize)
      }
      if (this.$refs.operator) {
        addResizeListener(this.$refs.operator, this.onOpearatorResize)
      }
    })
  },
  beforeDestroy() {
    if (this.$refs.alert) {
      removeResizeListener(this.$refs.alert, this.onAlertResize)
    }
    if (this.$refs.operator) {
      removeResizeListener(this.$refs.operator, this.onOpearatorResize)
    }
  },
}
</script>

<style lang="less">
.data-grid {
  height: 100%;
  transition: unset!important;
  .ivu-card-body {
      height: 100%;
  }
  &-operator {
    padding-bottom: 10px;
    // text-align: right;
  }
  &-body {
    .el-pagination {
      * {
        vertical-align: middle!important;
      }
      .el-pagination__sizes {
        height: auto!important;
        line-height: initial!important;
      }
    }
  }
  &-pagination {
    .el-input__inner {
      padding-right: 3px!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/data-grid.vue